import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '~/shadcn/components/ui/Dialog';
import { Button } from '~/shadcn/components/ui/Button';

const ConfirmDialog = ({
    open,
    onCancel,
    onConfirm,
    title = 'Are you sure?',
    description = 'Unsaved data will be lost.',
}) => {
    return (
        <Dialog open={open} onOpenChange={(val) => !val && onCancel()}>
            <DialogContent className="sm:max-w-md">
                <DialogHeader>
                    <DialogTitle>{title}</DialogTitle>
                </DialogHeader>
                <p className="text-sm text-muted-foreground mb-4">{description}</p>
                <DialogFooter className="flex justify-end gap-2">
                    <Button variant="ghost" onClick={onCancel}>
                        Cancel
                    </Button>
                    <Button variant="destructive" onClick={onConfirm}>
                        Yes, Close
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};

export { ConfirmDialog };
